import Header from "../constant-screens/header";
import Navbar from "../constant-screens/navbar";
import Footer from "../constant-screens/footer";
import LegalDocScreenBody from "../half-screens/legalDocScreenBody";

function LegalDoc() {
 return(
  <div>
   <Header />
   <Navbar />
   <LegalDocScreenBody />
   <Footer />
  </div>
 );
}

export default LegalDoc;